import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Flex,
  FormField,
  Text,
  TextInput,
} from '../../../components';
import api from '../../../utils/services';
import { updateCarrier as updateCarrierAction } from '../../../modules/carrier';


const propTypes = {
  carrierId: PropTypes.string,
  updateCarrier: PropTypes.func.isRequired,
  successCallback: PropTypes.func,
};

const defaultProps = {
  carrierId: null,
  successCallback: () => {},
};

// If a carrier id is passed, this will be an edit form
// If not, this will be a new Carrier form
class CarrierForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carrier: {},
      errors: {},
      loading: true,
      saving: false,
    };
  }

  componentDidMount() {
    const { carrierId } = this.props;
    if (carrierId) {
      api.carrier(carrierId)
        .then(carrier => this.setState({
          carrier,
          loading: false,
        }));
    } else {
      this.setState({ loading: false });
    }
  }

  handleChange = ({ target: { value, name } }) => {
    this.setState(prevState => ({
      carrier: {
        ...prevState.carrier,
        [name]: value,
      },
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { successCallback, updateCarrier } = this.props;
    const { carrier } = this.state;

    if (!this.validateForm()) {
      return;
    }
    this.setState({ saving: true });
    const payload = { ...carrier };
    delete payload.id;

    if (carrier.id) { // Edit case
      api.updateCarrier(carrier.id, carrier)
        .then((savedCarrier) => {
          updateCarrier(savedCarrier);
          this.setState({ saving: false });
          successCallback(savedCarrier);
        }).catch(() => {
          this.setState({
            errors: {
              save: 'Save failed, please try again',
            },
            saving: false,
          });
        });
    } else { // Add case
      api.addCarrier(carrier)
        .then((savedCarrier) => {
          this.setState({ saving: false });
          successCallback(savedCarrier);
        }).catch(() => {
          this.setState({
            errors: {
              save: 'Creation failed, please try again',
            },
            saving: false,
          });
        });
    }
  }

  // True if it passes validation
  validateForm = () => {
    const { carrier } = this.state;
    const errors = {};

    // Name is validated by being required

    if (carrier.aqeCarrierId && !Number.isInteger(+carrier.aqeCarrierId)) {
      errors.aqeCarrierId = 'AQE Carrier Id must be an integer or empty';
    }

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  }

  render() {
    const {
      carrier,
      errors,
      loading,
      saving,
    } = this.state;

    let textLoading = null;
    if (loading) {
      textLoading = 'Loading...';
    }

    return (
      <form onSubmit={this.handleSubmit}>
        {errors.save && <Text color="red">{errors.save}</Text>}
        <Flex>
          <Flex.Item grow={1}>
            <FormField
              label="Carrier Name"
              input={TextInput}
              name="name"
              value={textLoading || carrier.name || ''}
              onChange={this.handleChange}
              required
              disabled={loading}
            />
          </Flex.Item>
          <Flex.Item grow={1}>
            <FormField
              label="AQE Carrier Id"
              input={TextInput}
              name="aqeCarrierId"
              value={textLoading || `${carrier.aqeCarrierId || ''}`}
              onChange={this.handleChange}
              caption={errors.aqeCarrierId}
              variant={errors.aqeCarrierId ? 'danger' : undefined}
              disabled={loading}
            />
          </Flex.Item>
        </Flex>
        <Flex paddingTop="1em">
          <Flex.Item marginStart="auto">
            <Button primary disabled={loading} loading={saving} type="submit">Save</Button>
          </Flex.Item>
        </Flex>
      </form>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  updateCarrier: carrier => dispatch(updateCarrierAction(carrier)),
});

CarrierForm.propTypes = propTypes;
CarrierForm.defaultProps = defaultProps;
export default connect(undefined, mapDispatchToProps)(CarrierForm);
